import React, { useEffect } from 'react';
import AuthLayout from '../../components/auth-layout';
import { navigate } from 'gatsby';
import routes from '../../routes';
import InvoicePaymentAuth from '../../components/invoice-payment-portal/auth/InvoicePaymentAuth';
import useInvoicePaymentAuth from '../../hooks/invoice-payment-portal/useInvoicePaymentAuth';

export default function Auth() {
  
  const { isAuthenticated } = useInvoicePaymentAuth();

  useEffect(() => {
      if (isAuthenticated) {
          void navigate(routes.INVOICE_PAYMENT_PORTAL_INVOICE_LIST);        
      }    
  }, []);

  
  return isAuthenticated ? null : (
    <AuthLayout footer={<></>} showLeft={false}>
      <InvoicePaymentAuth />
    </AuthLayout>
  );
}
